import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Search } from "lucide-react";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setItems(data)); }, []);

  const qq = q.trim().toLowerCase();
  const filtered = qq
    ? items.filter((a) => [a.user_email, a.action, a.entity, a.entity_id]
        .filter(Boolean).some((v) => String(v).toLowerCase().includes(qq)))
    : items;

  return (
    <div data-testid="page-audit" className="space-y-5">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-slate-500">Admin</div>
        <h1 className="font-heading text-3xl font-extrabold text-slate-900 mt-1">Audit Logs</h1>
      </div>

      <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-md px-3 py-2 max-w-xl">
        <Search size={14} className="text-slate-400" />
        <input
          data-testid="input-audit-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search user, action, entity, ref…"
          className="flex-1 outline-none text-sm bg-transparent"
        />
        {q && <button onClick={() => setQ("")} className="text-xs text-slate-500 hover:text-slate-700">Clear</button>}
      </div>

      <div className="bg-white border border-slate-200 rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 text-left">
              <th className="px-5 py-3">Time</th><th className="px-5 py-3">User</th>
              <th className="px-5 py-3">Action</th><th className="px-5 py-3">Entity</th>
              <th className="px-5 py-3">Ref</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((a) => (
              <tr key={a.id} className="table-row border-t border-slate-100">
                <td className="px-5 py-3 text-xs text-slate-500">{new Date(a.at).toLocaleString()}</td>
                <td className="px-5 py-3 text-slate-700">{a.user_email || "-"}</td>
                <td className="px-5 py-3 font-mono text-xs">{a.action}</td>
                <td className="px-5 py-3">{a.entity}</td>
                <td className="px-5 py-3 text-xs text-slate-500 font-mono">{a.entity_id?.slice(0, 8)}</td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan="5" className="py-8 text-center text-slate-500">{q ? `No matches for "${q}"` : "No audit logs yet"}</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
